import classNames from 'classnames';
import React from 'react';

import {Owner} from 'auth/PermissionConstants';
import * as HelpModals from 'help/Modals';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import LegacyFieldError from 'ui-library/bs/LegacyFieldError';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import HelpIcon from 'ui-library/icons/HelpIcon';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import {ElementMouseEvent} from 'util/Types';

export interface SelectOwnerFieldProps {
  error?: string;
  ownableType: string;
  isReadOnly: boolean;
  ownerId: string;
  selectOwner: (ownerId: string) => void;
  potentialOwners: Array<Owner>;
  collaboratorsAllowed: boolean;
  helpMessage: JSX.Element;
  useFieldSubLabelStyle?: boolean;
}

/**
 * Controlled component to select an owner for an ownable. Tested in OwnableSettingsModal-test.
 */
export default function SelectOwnerField({
  error,
  isReadOnly,
  ownerId,
  selectOwner,
  potentialOwners,
  helpMessage,
  useFieldSubLabelStyle = false,
}: SelectOwnerFieldProps): JSX.Element {
  function _handleClickOwnerHelp(e: ElementMouseEvent): void {
    HelpModals.showBasicHelpModal(e, 'Ownership', helpMessage);
  }

  return (
    <FormGroup dataTestAttrs={{component: 'SelectOwnerField', element: 'root'}} hasError={error != null}>
      <Label className={classNames({'fieldLabel-sublabel': useFieldSubLabelStyle})}>
        Owner
        <HelpIcon onClick={_handleClickOwnerHelp} className="u-tiny-spacing-left" />
      </Label>
      <SelectDropdown
        disabled={isReadOnly}
        displayName={potentialOwners.find(({id}) => id === ownerId)!.name}
        menu={
          <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FULL} value={ownerId}>
            {potentialOwners.map(({name, id}) => (
              <Option
                key={id}
                value={id}
                onSelect={(value: string) => {
                  selectOwner(value);
                }}
              >
                {name}
              </Option>
            ))}
          </Menu>
        }
      />
      <LegacyFieldError message={error} />
    </FormGroup>
  );
}
